import { AxiosResponse } from "axios";
import instance from "./axiosInstance";
import { AddClientRequest, AddClientResponse, GetClientsListResponse, ListResultLinkRequest, ListResultLinkResponse } from "../types/clients/types";

export const addClient = async (accessToken: string, data: AddClientRequest): Promise<AddClientResponse> => {
  try {
    const response: AxiosResponse<AddClientResponse> = await instance.post(`/api/v1/services/createLink`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error adding client:", error);
    throw error;
  }
};

export const getClientsList = async (accessToken: string, page: number = 1): Promise<GetClientsListResponse> => {
  try {
    const response: AxiosResponse<GetClientsListResponse> = await instance.get(`/api/v1/services/listLink`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      params: { page },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error fetching clients list:", error);
    throw error;
  }
};

export const generateClientLink = (ref_id: string): string => {
  return `https://app.shaku.tech/en/guest/services?ref=${ref_id}`;
};

export const getClientServiceResults = async (accessToken: string, data: ListResultLinkRequest): Promise<ListResultLinkResponse> => {
  try {
    const response: AxiosResponse<ListResultLinkResponse> = await instance.post(`/api/v1/services/listResultLink`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error fetching client service results:", error);
    throw error;
  }
};
